import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/authService';
import { authConfig, loadAuthConfig } from '../config/authConfig';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [authError, setAuthError] = useState(null);

    useEffect(() => {
        loadAuthConfig();
        // Проверяем сохраненную сессию
        const checkAuth = async () => {
            if (authService.isAuthenticated()) {
                const userData = authService.getUser();
                setUser(userData);
                setIsAuthenticated(true);

                // Проверяем валидность токена
                const isValid = await authService.refreshToken();
                if (!isValid) {
                    logout();
                }
            }
            setLoading(false);
        };

        checkAuth();
    }, []);

    const login = async (credentials) => {
        setAuthError(null);
        const result = await authService.login(credentials);

        if (result.success) {
            // console.log("Result: " + authService.getToken());
            result.user = authService.fetchCurrentUserInfo();
            console.log("User: ", JSON.stringify(result.user));
            // setUser(result.user);
            // console.log("User: ", JSON.stringify(getUser()));
            setIsAuthenticated(true);
            return { success: true };
        } else {
            setAuthError(result.error);
            return { success: false, error: result.error };
        }
    };

    const register = async (userData) => {
        setAuthError(null);
        const result = await authService.register(userData);

        if (result.success) {
            setUser(result.user);
            setIsAuthenticated(true);
            return { success: true };
        } else {
            setAuthError(result.error);
            return { success: false, error: result.error };
        }
    };

    const logout = async () => {
        console.log("LOGOUT")
        await authService.logout();
        setUser(null);
        setIsAuthenticated(false);
        setAuthError(null);
    };

    const updateServerUrl = (newUrl) => {
        authService.updateServerUrl(newUrl);
    };

    return (
        <AuthContext.Provider value={{
            user,
            isAuthenticated,
            loading,
            authError,
            login,
            register,
            logout,
            updateServerUrl
        }}>
            {children}
        </AuthContext.Provider>
    );
};
